import {Component, Input, computed, inject, signal} from '@angular/core';
import {Router} from '@angular/router';
import {DashboardOverviewStats} from '../../../dashboard-analytics/models/dashboard-statistics.model';

interface DonutSegment {
  key: string;
  label: string;
  count: number;
  color: string;
  pct: number;
  dasharray: string;
  dashoffset: string;
}

@Component({
  selector: 'app-file-status-donut',
  templateUrl: './file-status-donut.component.html',
  styleUrls: ['./file-status-donut.component.css']
})
export class FileStatusDonutComponent {

  private readonly router = inject(Router);

  private readonly _overview = signal<DashboardOverviewStats | null>(null);

  openFileService(): void {
    this.router.navigate(['/app/file-service']);
  }

  @Input() set overview(value: DashboardOverviewStats | null) {
    this._overview.set(value);
  }
  get overview(): DashboardOverviewStats | null {
    return this._overview();
  }

  @Input() isLoading: boolean = false;

  // Donut math constants
  private readonly RADIUS = 62;
  private readonly CIRCUMFERENCE = 2 * Math.PI * this.RADIUS; // ≈ 389.56

  readonly total = computed(() => {
    const o = this._overview();
    if (!o) return 0;
    return (o.importsSuccessful || 0) + (o.importsPartial || 0) + (o.importsFailed || 0);
  });

  readonly segments = computed<DonutSegment[]>(() => {
    const o = this._overview();
    if (!o) return [];
    const tot = this.total();
    if (tot === 0) return [];

    const raw = [
      {key: 'inProgress', label: 'In Progress', count: 0, color: '#7C5CFC'},
      {key: 'successful', label: 'Successful',  count: o.importsSuccessful || 0, color: '#8AF0A8'},
      {key: 'partial',    label: 'Partial',     count: o.importsPartial || 0,    color: '#E8A838'},
      {key: 'failed',     label: 'Failed',      count: o.importsFailed || 0,     color: '#FF6B8B'}
    ];

    let cursor = 0;
    return raw.map((seg) => {
      const pct = tot ? seg.count / tot : 0;
      const length = Math.max(pct * this.CIRCUMFERENCE, 0);
      const result: DonutSegment = {
        ...seg,
        pct: Math.round(pct * 1000) / 10,
        dasharray: `${length} ${this.CIRCUMFERENCE - length}`,
        dashoffset: `-${cursor}`
      };
      cursor += length;
      return result;
    });
  });
}
